// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2p5Pm","col":"styles_col__2gIEo"};